"use client";

import React from "react";
import Link from "next/link";
import { Clock, Map, BarChart3, Heart, Calendar, Zap, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

export function WelcomeScreen() {
  return (
    <div className="flex h-full overflow-hidden">
      <div className="flex flex-col w-full min-h-0">
        {/* Main Content - Scrollable */}
        <div className="flex-1 overflow-y-auto scrollbar-thin">
          <div className="w-full max-w-4xl mx-auto px-4 py-4 md:py-8 lg:py-0 lg:flex lg:flex-col lg:justify-center lg:min-h-full">
            {/* Desktop: Center content vertically */}
            <div className="lg:flex-1 lg:flex lg:flex-col lg:justify-center">{/* Content wrapper for centering */}
            {/* Mobile Free Registration Button - Only visible on mobile */}
            <div className="md:hidden mb-6">
              <Link href="/register" className="block">
                <Button className="w-full bg-transparent hover:bg-white/10 border-0 text-white hover:text-gray-200 py-4 text-lg font-semibold shadow-lg">
                  <UserPlus className="h-5 w-5 mr-3" />
                  Ücretsiz Kayıt Ol
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 lg:gap-6 mb-6 md:mb-8">
              {/* Doğum Saati Bulma */}
              <Link
                href="/register"
                className="group relative bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg p-4 md:p-5 lg:p-6 transition-all duration-200 text-left flex flex-col justify-between h-36 md:h-36 lg:h-40 shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center gap-3 mb-2">
                  <Clock className="h-6 w-6 md:h-5 md:w-5 text-blue-400 flex-shrink-0" />
                  <h4 className="text-lg md:text-lg font-semibold text-slate-200 leading-tight">Doğum Saatini<br />Öğren</h4>
                </div>
                <hr className="border-slate-600 my-2" />
                <p className="text-sm md:text-sm text-slate-300 md:text-slate-400 h-10 flex items-center text-left line-clamp-2">Doğum saatinizi belirlemek için rehberlik</p>
                <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                </div>
              </Link>

              {/* Doğum Haritası Oluşturma */}
              <Link
                href="/register"
                className="group relative bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg p-4 md:p-5 lg:p-6 transition-all duration-200 text-left flex flex-col justify-between h-36 md:h-36 lg:h-40 shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center gap-3 mb-2">
                  <Map className="h-6 w-6 md:h-5 md:w-5 text-purple-400 flex-shrink-0" />
                  <h4 className="text-lg md:text-lg font-semibold text-slate-200 leading-tight">Doğum Haritası<br />Oluşturma</h4>
                </div>
                <hr className="border-slate-600 my-2" />
                <p className="text-sm md:text-sm text-slate-300 md:text-slate-400 h-10 flex items-center text-left line-clamp-2">Kişisel astroloji haritanızı oluşturun</p>
                <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                </div>
              </Link>

              {/* Doğum Haritası Değerlendirme */}
              <Link
                href="/register"
                className="group relative bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg p-4 md:p-5 lg:p-6 transition-all duration-200 text-left flex flex-col justify-between h-36 md:h-36 lg:h-40 shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center gap-3 mb-2">
                  <BarChart3 className="h-6 w-6 md:h-5 md:w-5 text-green-400 flex-shrink-0" />
                  <h4 className="text-lg md:text-lg font-semibold text-slate-200 leading-tight">Doğum Haritası<br />Değerlendirme</h4>
                </div>
                <hr className="border-slate-600 my-2" />
                <p className="text-sm md:text-sm text-slate-300 md:text-slate-400 h-10 flex items-center text-left line-clamp-2">Haritanızı analiz edin ve sohbet edin</p>
                <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                </div>
              </Link>

              {/* İlişki Yorumlama */}
              <Link
                href="/register"
                className="group relative bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg p-4 md:p-5 lg:p-6 transition-all duration-200 text-left flex flex-col justify-between h-36 md:h-36 lg:h-40 shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center gap-3 mb-2">
                  <Heart className="h-6 w-6 md:h-5 md:w-5 text-pink-400 flex-shrink-0" />
                  <h4 className="text-lg md:text-lg font-semibold text-slate-200 leading-tight">İlişki<br />Yorumlama</h4>
                </div>
                <hr className="border-slate-600 my-2" />
                <p className="text-sm md:text-sm text-slate-300 md:text-slate-400 h-10 flex items-center text-left line-clamp-2">İlişki uyumunuzu astrolojik olarak inceleyin</p>
                <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                </div>
              </Link>

              {/* Günlük Yorum */}
              <Link
                href="/register"
                className="group relative bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg p-4 md:p-5 lg:p-6 transition-all duration-200 text-left flex flex-col justify-between h-36 md:h-36 lg:h-40 shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center gap-3 mb-2">
                  <Calendar className="h-6 w-6 md:h-5 md:w-5 text-orange-400 flex-shrink-0" />
                  <h4 className="text-lg md:text-lg font-semibold text-slate-200 leading-tight">Günlük<br />Yorum</h4>
                </div>
                <hr className="border-slate-600 my-2" />
                <p className="text-sm md:text-sm text-slate-300 md:text-slate-400 h-10 flex items-center text-left line-clamp-2">Bugünkü astrolojik yorumunuzu alın</p>
                <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                </div>
              </Link>

              {/* Tarot Okuması */}
              <Link
                href="/register"
                className="group relative bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg p-4 md:p-5 lg:p-6 transition-all duration-200 text-left flex flex-col justify-between h-36 md:h-36 lg:h-40 shadow-lg hover:shadow-xl"
              >
                <div className="flex items-center gap-3 mb-2">
                  <Zap className="h-6 w-6 md:h-5 md:w-5 text-yellow-400 flex-shrink-0" />
                  <h4 className="text-lg md:text-lg font-semibold text-slate-200 leading-tight">Tarot<br />Okuması</h4>
                </div>
                <hr className="border-slate-600 my-2" />
                <p className="text-sm md:text-sm text-slate-300 md:text-slate-400 h-10 flex items-center text-left line-clamp-2">Tarot kartları ile rehberlik alın</p>
                <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-2 h-2 bg-slate-400 rounded-full"></div>
                </div>
              </Link>
            </div>

            {/* Terms and Disclaimer - Stays close to cards */}
            <div className="text-center mb-6 lg:mb-8">
              <p className="text-xs md:text-sm text-white mb-4">
                Hizmetlerimizi kullanarak{" "}
                <a
                  href="/kullanim-kosullari"
                  className="text-blue-400 hover:text-blue-300 underline transition-colors"
                >
                  Kullanım Koşulları
                </a>
                {" "}mızı kabul etmiş sayılırsınız.
              </p>
              <div className="max-w-4xl mx-auto">
                <p className="text-xs md:text-sm text-amber-300 leading-relaxed font-bold">
                  ✨ Astroloji kesinlik taşıyan bir bilim dalı değil, kişisel farkındalık ve rehberlik amacıyla kullanılan sembolik bir yorumlama aracıdır.
                </p>
              </div>
            </div>

            {/* Corporate Footer - Right after disclaimer */}
            <div className="border-t border-slate-800 pt-6 lg:pt-8 mb-6 lg:mb-8">
              <div className="max-w-4xl lg:max-w-none lg:w-full mx-auto">
                {/* Mobile Footer Layout - UX Optimized */}
                <div className="md:hidden">
                  {/* Mobile Main CTA Section */}
                  <div className="text-center mb-8">
                    <div className="mb-4">
                      <h3 className="text-xl font-bold text-slate-100 mb-2">AXTROLOG</h3>
                      <p className="text-sm text-slate-300 leading-relaxed max-w-xs mx-auto">
                        Yapay zeka destekli astroloji rehberlik platformu
                      </p>
                    </div>
                    {/* Primary CTAs - Larger touch targets */}
                    <div className="space-y-3">
                      <a
                        href="/register"
                        className="block w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white px-6 py-4 rounded-xl font-semibold text-base transition-all duration-200 shadow-lg"
                      >
                        Ücretsiz Başla
                      </a>
                      <a
                        href="mailto:destek@axtrolog.com"
                        className="block w-full border-2 border-slate-600 hover:border-slate-400 active:border-slate-300 text-slate-300 hover:text-slate-100 px-6 py-4 rounded-xl font-semibold text-base transition-all duration-200"
                      >
                        Destek Al
                      </a>
                    </div>
                  </div>

                  {/* Mobile Navigation Links - Organized sections */}
                  <div className="space-y-6 mb-8">
                    {/* Quick Access Section */}
                    <div>
                      <h4 className="text-base font-semibold text-slate-200 mb-4 text-center">
                        Keşfet
                      </h4>
                      <div className="grid grid-cols-2 gap-3">
                        <a
                          href="/about"
                          className="bg-slate-800/50 hover:bg-slate-700/60 active:bg-slate-700 text-slate-300 hover:text-slate-100 py-4 px-4 rounded-lg text-sm font-medium text-center transition-all duration-200 border border-slate-700/50"
                        >
                          Hakkımızda
                        </a>
                        <a
                          href="/about/astrology"
                          className="bg-slate-800/50 hover:bg-slate-700/60 active:bg-slate-700 text-slate-300 hover:text-slate-100 py-4 px-4 rounded-lg text-sm font-medium text-center transition-all duration-200 border border-slate-700/50"
                        >
                          Astroloji Rehberi
                        </a>
                      </div>
                    </div>

                    {/* Legal & Support Section */}
                    <div>
                      <h4 className="text-base font-semibold text-slate-200 mb-4 text-center">
                        Bilgi & Destek
                      </h4>
                      <div className="space-y-3">
                        <a
                          href="/kullanim-kosullari"
                          className="block bg-slate-800/30 hover:bg-slate-700/40 active:bg-slate-700/50 text-slate-400 hover:text-slate-200 py-3 px-4 rounded-lg text-sm text-center transition-all duration-200 border border-slate-700/30"
                        >
                          Kullanım Koşulları
                        </a>
                        <a
                          href="/gizlilik-politikasi"
                          className="block bg-slate-800/30 hover:bg-slate-700/40 active:bg-slate-700/50 text-slate-400 hover:text-slate-200 py-3 px-4 rounded-lg text-sm text-center transition-all duration-200 border border-slate-700/30"
                        >
                          Gizlilik Politikası
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Contact Section */}
                  <div className="text-center space-y-3 pb-8">
                    <div className="bg-slate-800/40 rounded-lg p-4 border border-slate-700/50">
                      <p className="text-sm text-slate-300 mb-2">İletişim</p>
                      <a
                        href="mailto:info@axtrolog.com"
                        className="text-blue-400 hover:text-blue-300 active:text-blue-200 font-medium transition-colors duration-200"
                      >
                        info@axtrolog.com
                      </a>
                    </div>

                    {/* Copyright & Company Info */}
                    <div className="text-xs text-slate-500 space-y-2 leading-relaxed">
                      <p>© 2025 Axtrolog. Tüm hakları saklıdır.</p>
                      <p className="text-slate-600">
                        PIXAGOR Veri Merkezi ve Yazılım Hizmetleri A.Ş.
                      </p>
                      {/* Pixagor Logo */}
                      <div className="flex justify-center pt-2">
                        <img
                          src="/images/pixagor-logo-white.svg"
                          alt="Pixagor Logo"
                          className="h-6 opacity-60"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Desktop Footer Layout */}
                <div className="hidden md:grid grid-cols-4 gap-6 md:gap-6 lg:gap-6 text-center md:text-left">
                  {/* Company Info */}
                  <div className="flex flex-col items-center md:items-start">
                    <h3 className="text-lg font-bold text-slate-100 mb-3">AXTROLOG</h3>
                    <p className="text-xs md:text-sm text-slate-400 leading-relaxed mb-3">
                      Yapay zeka destekli astroloji ve tarot rehberlik platformu.
                      Kişisel gelişim yolculuğunuzda yanınızdayız.
                    </p>
                    <p className="text-xs md:text-sm text-slate-500">© 2025 Axtrolog. Tüm hakları saklıdır.</p>
                  </div>

                  {/* Quick Links */}
                  <div className="flex flex-col items-center md:items-start">
                    <h4 className="text-sm md:text-base font-semibold text-slate-200 mb-3 uppercase">Hızlı Erişim</h4>
                    <hr className="w-full border-slate-600 mb-3" />
                    <ul className="space-y-2 text-xs md:text-sm text-slate-400">
                      <li>
                        <a href="/about" className="hover:text-slate-100 transition-colors">
                          Hakkımızda
                        </a>
                      </li>
                      <li>
                        <a href="/about/astrology" className="hover:text-slate-100 transition-colors">
                          Astroloji Rehberi
                        </a>
                      </li>
                      <li>
                        <a href="/about/tarot" className="hover:text-slate-100 transition-colors">
                          Tarot Rehberi
                        </a>
                      </li>
                      <li>
                        <a href="/register" className="hover:text-slate-100 transition-colors">
                          Ücretsiz Kayıt
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Legal Links */}
                  <div className="flex flex-col items-center md:items-start">
                    <h4 className="text-sm md:text-base font-semibold text-slate-200 mb-3 uppercase">Yasal</h4>
                    <hr className="w-full border-slate-600 mb-3" />
                    <ul className="space-y-2 text-xs md:text-sm text-slate-400">
                      <li>
                        <a href="/kullanim-kosullari" className="hover:text-slate-100 transition-colors">
                          Kullanım Koşulları
                        </a>
                      </li>
                      <li>
                        <a href="/gizlilik-politikasi" className="hover:text-slate-100 transition-colors">
                          Gizlilik Politikası
                        </a>
                      </li>
                      <li>
                        <a href="/about/usage-framework" className="hover:text-slate-100 transition-colors">
                          Kullanım Çerçevesi
                        </a>
                      </li>
                      <li>
                        <span className="text-slate-500">İletişim: info@axtrolog.com</span>
                      </li>
                    </ul>
                  </div>

                  {/* Support Section */}
                  <div className="flex flex-col items-center md:items-start">
                    <h4 className="text-sm md:text-base font-semibold text-slate-200 mb-3 uppercase">Destek</h4>
                    <hr className="w-full border-slate-600 mb-3" />
                    <ul className="space-y-2 text-xs md:text-sm text-slate-400">
                      <li>
                        <a href="mailto:destek@axtrolog.com" className="hover:text-slate-100 transition-colors">
                          Teknik Destek
                        </a>
                      </li>
                      <li>
                        <a href="/about/usage-framework" className="hover:text-slate-100 transition-colors">
                          Kullanım Rehberi
                        </a>
                      </li>
                      <li>
                        <a href="/about" className="hover:text-slate-100 transition-colors">
                          Genel Sorular
                        </a>
                      </li>
                      <li>
                        <span className="text-slate-500">7/24 Canlı Destek</span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Company Legal Name - Desktop Only */}
                <div className="hidden md:block col-span-full mt-6 pt-4 border-t border-slate-700 text-center space-y-3">
                  <p className="text-xs md:text-sm text-slate-500">
                    PIXAGOR Veri Merkezi ve Yazılım Hizmetleri A.Ş.
                  </p>
                  {/* Pixagor Logo */}
                  <div className="flex justify-center">
                    <img
                      src="/images/pixagor-logo-white.svg"
                      alt="Pixagor Logo"
                      className="h-8 opacity-60"
                    />
                  </div>
                </div>

                {/* Mobile Footer Spacer */}
                <div className="md:hidden h-6"></div>
              </div>
            </div>

            </div> {/* End content wrapper */}
          </div>
        </div>
      </div>
    </div>
  );
}